/* angular:styles/component:scss;1e99ee068b85e187e552d95337bba60ba5207c068c55c5ea524a574d8207468b;/home/vsts/work/1/s/Autocare.Api/ClientApp/src/app/module/service-provider/multiFile-type.ts */
.custom-file-upload {
  display: inline-block;
  position: relative;
}
.error-message {
  color: #e24c4c;
  font-size: 13px;
  margin-top: 2px;
}
.upload-label {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #344054;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.upload-label.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.upload-label:hover:not(.disabled) {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}
input[type=file] {
  display: none;
}
.file-list {
  margin-top: 10px;
}
.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9fafb;
  border: 1px solid #d0d5dd;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 6px;
}
.file-name {
  color: #344054;
  cursor: pointer;
  flex-grow: 1;
  transition: font-weight 0.3s ease, text-decoration 0.3s ease;
}
.file-name.hovered {
  font-weight: bold;
  text-decoration: underline;
}
.remove-button {
  background: none;
  border: none;
  color: red;
  cursor: pointer;
}
.modal-image {
  max-width: 100%;
  max-height: 60vh;
  display: block;
  margin: 0 auto;
}
.file-info {
  display: flex;
  align-items: center;
}
.file-icon {
  font-size: 24px;
  margin-right: 10px;
}
.file-details {
  display: flex;
  flex-direction: column;
}
.file-size {
  font-size: 12px;
  color: #6b7280;
}
.progress-bar {
  width: 100%;
  height: 6px;
  background: #f3f4f6;
  border-radius: 3px;
  margin-top: 5px;
  margin-bottom: 8px;
}
.progress-fill {
  height: 100%;
  width: 80%;
  background: #f97316;
  border-radius: 3px;
  transition: width 0.5s;
}
/*# sourceMappingURL=multiFile-type-3ZZG5CEW.css.map */
